import { render } from "./CommonMessage.vue?vue&type=template&id=1ccd4ab4&ts=true"
import script from "./CommonMessage.vue?vue&type=script&lang=ts"
export * from "./CommonMessage.vue?vue&type=script&lang=ts"

import exportComponent from "/deploy/src/necs_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__